module.exports = __webpack_public_path__ + "img/icon6.b2dfddc2.png";